const STORAGE_KEY = "paidEventSignupSession";
const SESSION_TIMESTAMP_KEY = "paidEventSignupTimestamp";
const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export const initializePaidEventSession = (eventData) => {
  if (!eventData?.eventId) {
    return;
  }

  const sessionData = {
    eventId: eventData.eventId,
    eventTitle: eventData.eventTitle || "Event",
    isPaidEvent: eventData.isPaidEvent || false,
    timestamp: new Date().toISOString(),
    source: "paid-event-interest",
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(sessionData));
  sessionStorage.setItem(SESSION_TIMESTAMP_KEY, Date.now().toString());

};

export const getPaidEventSession = () => {
  try {
    const sessionData = sessionStorage.getItem(STORAGE_KEY);
    const timestamp = sessionStorage.getItem(SESSION_TIMESTAMP_KEY);

    if (!sessionData || !timestamp) {
      return null;
    }

    const sessionAge = Date.now() - parseInt(timestamp, 10);
    if (sessionAge > SESSION_TIMEOUT_MS) {
      clearPaidEventSession();
      return null;
    }

    return JSON.parse(sessionData);
  } catch (error) {
    clearPaidEventSession();
    return null;
  }
};

export const hasPaidEventSession = () => {
  return getPaidEventSession() !== null;
};

export const clearPaidEventSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(SESSION_TIMESTAMP_KEY);
};

export const completePaidEventSignup = () => {
  clearPaidEventSession();
};

export const transferToPostSignupInterest = () => {
  const sessionData = getPaidEventSession();

  if (!sessionData) {
    return null;
  }

  const pendingInterest = {
    eventId: sessionData.eventId,
    eventTitle: sessionData.eventTitle,
    isPaidEvent: sessionData.isPaidEvent,
    timestamp: new Date().toISOString(),
    source: "post-signup-interest",
  };

  localStorage.setItem("pendingEventInterest", JSON.stringify(pendingInterest));

  return pendingInterest;
};

export const cleanupOnPageLoad = () => {
  const session = getPaidEventSession();

  if (!session) {
    clearPaidEventSession();
  }
};
